// extracted by mini-css-extract-plugin
export default {"LoginFormParentContainer":"LoginForm_LoginFormParentContainer__4nifD"};